"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yourOfferLabel = exports.paymentToYou = exports.breakdownAmountLabel = exports.amountYouOwe = exports.applyAsDownPaymentLabel = void 0;
var amountYouOwe = 'Amount you owe';
exports.amountYouOwe = amountYouOwe;
var applyAsDownPaymentLabel = 'We’ll apply this amount as the down payment on your next car.';
exports.applyAsDownPaymentLabel = applyAsDownPaymentLabel;
var breakdownAmountLabel = 'Your offer';
exports.breakdownAmountLabel = breakdownAmountLabel;
var paymentToYou = 'Payment to you';
exports.paymentToYou = paymentToYou;
var yourOfferLabel = 'Your trade in offer';
exports.yourOfferLabel = yourOfferLabel;
